import logo from '@/assets/plans/zoom_scheduler.svg';
import {
  BASE_PLAN_TYPES,
  BILLING_CYCLE,
  planTypes,
} from '@/common/constants';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import PlanDetails from '../components/plan-details';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { debounce, get, groupBy, throttle } from 'lodash';
import plansMixin from '@/plans/mx/plan';
import { isEmptyVal } from '@/utils';
import { isZoomSchedulerAsAddonCard, additionalZoomSchedulerAsAddonCardCheck } from '@/plans/ZOOM_MEETING/common/utils';
import { getPlanUnitWithCycle } from "@/common/product-unit";
import {
  canRemoveAddOnPlanInWinBack,
  isFromShoppingCart,
  isProductCanRemove,
} from '@/views/config/shopping-cart/persist/plan-remove';

export default {
  mixins: [plansMixin],
  data() {
    return {
      title: this.$t('billing.scheduler.title'),
      trackingPlanName: this.$t('billing.scheduler.title'),
      planType: planTypes.ZOOM_SCHEDULER,
      logo,
      isExpanded: true,
      form: {
        category: 'zsched',
        billingCycle: 'annual',
        selectedNumber: 1,
      },
      oldPlanCode: '',
      BILLING_CYCLE: BILLING_CYCLE,
      planDetailsDialog: new ServiceConfirm(PlanDetails, this.$store),
      showPlanDetail: false,
      isInitUpdateForm: false,
      specialTrackingFlowTypes: '',
      getPlanUnitWithCycle
    };
  },
  created() {
    this.updateForm(true);
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['getSelectedPlans', 'getUserCurrentSubscriptions', 'getCurrentBasePlanInfo', 'assignInfo']),
    isLastBasePlan() {
      if (!BASE_PLAN_TYPES.includes(planTypes.ZOOM_SCHEDULER)) return false; // is not base plan  FIXME: this can't be reached
      let baseTypes = this.getSelectedPlans.map((x) => x.type).filter((x) => BASE_PLAN_TYPES.includes(x)); // base plans among these
      if (baseTypes.length === 1 && baseTypes[0] === planTypes.ZOOM_SCHEDULER) return true; // only when
      return false;
    },
    couldBeRemovedAsAddonCard() {
      if (this.soft_bundle_hiddenRemoveBtn) return false;
      if(isFromShoppingCart()) {
        return isProductCanRemove(this.currentPlans[0])
      }
      return !this.isLastBasePlan && isZoomSchedulerAsAddonCard() || canRemoveAddOnPlanInWinBack(planTypes.ZOOM_SCHEDULER);
    },
    isZoomSchedulerAsAddonCard() {
      return additionalZoomSchedulerAsAddonCardCheck(this.getSelectedPlans)
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_SCHEDULER);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    currentPlans() {
      return this.zonePlanGroupByCategory[this.form.category];
    },
    annualPriceM() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount * 12 : 0;
    },
    annalPriceSave() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (this.annualPriceM && annualPlan) {
        return this.annualPriceM - annualPlan.amount;
      }
      return 0;
    },
    saveLabel() {
      return {
        [BILLING_CYCLE.MONTHLY]: '',
        [BILLING_CYCLE.ANNUAL]: this.annalPriceSave > 0
          ? `${this.$money(this.annalPriceSave)} ${this.$t('billing.annual_save')}`
          : '',
      };
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.form.billingCycle,
      );
    },
    totalCoast() {
      if (this.formPlan) {
        return this.formPlan.amount * this.form.selectedNumber;
      }
      return 0;
    },
    minHost() {
      return this.formPlan ? this.formPlan.min : 1;
    },
    maxHost() {
      if(this.$context.is.editPage) return 9999;
      return this.formPlan ? this.formPlan.max : 99;
    },
    attendee() {
      return get(this.currentPlans, "[0].participants", 0);
    },
  },
  methods: {
    ...mapActions({
      switchSelectPlan: 'switchSelectPlan',
    }),
    ...mapMutations(['updateSelectPlan', 'savePersist']),
    // sync shopping cart plan to local form state
    updateForm(isInitUpdateForm = false) {
      const shoppingCartPlan = this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_SCHEDULER);
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = shoppingCartPlan.cartInfo.selected_number;
        this.oldPlanCode = shoppingCartPlan.plan_code;
      }

      this.isInitUpdateForm = isInitUpdateForm;
    },
    submitForm: throttle(function(v) {
      this.$nextTick(() => {
        if (!this.formPlan) {
          return;
        }

        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }

        if (this.formPlan.plan_code === this.oldPlanCode) {
          this.updateSelectPlan({
            ...this.formPlan,
            cartInfo: {
              selected_number: this.form.selectedNumber,
            },
          });
        } else {
          this.switchSelectPlan([
            this.oldPlanCode,
            this.formPlan.plan_code,
            {
              selected_number: this.form.selectedNumber,
            },
          ]);
        }
        this.updateForm();
      });
    }, 200),
    async updateBillingCycle(oldPlan, newPlan) {
      if (newPlan.plan_code === oldPlan?.plan_code) {
        await this.updateSelectPlan({
          ...newPlan,
          cartInfo: {
            selected_number: this.form.selectedNumber,
          },
        });
      } else {
        await this.switchSelectPlan([
          oldPlan?.plan_code,
          newPlan.plan_code,
          {
            selected_number: this.form.selectedNumber,
          },
        ]);
      }
      this.updateForm();
    },

    async handlePlanDetailsClick() {
      this.$tracking.buyInteraction('plan details selected', this.trackingPlanName, this.specialTrackingFlowTypes ? this.specialTrackingFlowTypes: undefined);
      await this.planDetailsDialog.confirm({ planCategory: this.formPlan.category }).catch(()=>{})
    },
    getBillingCycleDisabledDesc() {
      return false;
    },
    billingCycleDisabled(billingCycle) {
      return this.getBillingCycleDisabledDesc(billingCycle);
    },
  },
  watch: {
    isExpanded: {
      handler(val) {
        this.$tracking.buyInteraction(
          'product details accordion',
          `${this.trackingPlanName} - ${val ? 'expand' : 'collapse'}`,
          this.specialTrackingFlowTypes ? this.specialTrackingFlowTypes: undefined
        );
      },
    },
    'form.billingCycle': {
      handler: debounce(function(val) {
        !this.isInitUpdateForm && this.$tracking.buyInteraction(
          'billing cycle',
          `${this.trackingPlanName} - toggled billed ${val}`,
          this.specialTrackingFlowTypes ? this.specialTrackingFlowTypes: undefined
        );
      }, 500),
    },
    'form.selectedNumber': {
      handler: debounce(function(newLicense, oldLicense) {
        if (this.formPlan) {
          // event tracking
          !this.isInitUpdateForm && this.$tracking.buyInteraction('number of hosts',
            `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`);
        }
      }, 500),
    },
  },
};
